function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_606_952)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.896484 11.7532C1.06224 11.7532 1.22122 11.8124 1.33843 11.9179C1.45564 12.0234 1.52148 12.1665 1.52148 12.3157V15.1282C1.52148 15.4265 1.65318 15.7127 1.8876 15.9237C2.12202 16.1346 2.43996 16.2532 2.77148 16.2532H17.7715C18.103 16.2532 18.4209 16.1346 18.6554 15.9237C18.8898 15.7127 19.0215 15.4265 19.0215 15.1282V12.3157C19.0215 12.1665 19.0873 12.0234 19.2045 11.9179C19.3218 11.8124 19.4807 11.7532 19.6465 11.7532C19.8122 11.7532 19.9712 11.8124 20.0884 11.9179C20.2056 12.0234 20.2715 12.1665 20.2715 12.3157V15.1282C20.2715 15.7249 20.0081 16.2972 19.5393 16.7192C19.0704 17.1411 18.4345 17.3782 17.7715 17.3782H2.77148C2.10844 17.3782 1.47256 17.1411 1.00372 16.7192C0.534877 16.2972 0.271484 15.7249 0.271484 15.1282V12.3157C0.271484 12.1665 0.337332 12.0234 0.454543 11.9179C0.571753 11.8124 0.730724 11.7532 0.896484 11.7532Z",
  fill: "#385CAD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.82904 13.9515C9.8871 14.0039 9.95607 14.0454 10.032 14.0738C10.1079 14.1021 10.1893 14.1167 10.2715 14.1167C10.3538 14.1167 10.4352 14.1021 10.5111 14.0738C10.587 14.0454 10.656 14.0039 10.714 13.9515L14.464 10.5765C14.5814 10.4709 14.6473 10.3276 14.6473 10.1782C14.6473 10.0289 14.5814 9.8856 14.464 9.77997C14.3467 9.67435 14.1875 9.61501 14.0215 9.61501C13.8556 9.61501 13.6964 9.67435 13.579 9.77997L10.8965 12.1953V2.30322C10.8965 2.15404 10.8307 2.01096 10.7135 1.90548C10.5963 1.79999 10.4373 1.74072 10.2715 1.74072C10.1058 1.74072 9.94681 1.79999 9.8296 1.90548C9.71239 2.01096 9.64654 2.15404 9.64654 2.30322V12.1953L6.96404 9.77997C6.84668 9.67435 6.68751 9.61501 6.52154 9.61501C6.35557 9.61501 6.1964 9.67435 6.07904 9.77997C5.96168 9.8856 5.89575 10.0289 5.89575 10.1782C5.89575 10.3276 5.96168 10.4709 6.07904 10.5765L9.82904 13.9515Z",
  fill: "#385CAD"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_606_952"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.271484,
  y: 0.615723,
  width: 20,
  height: 18,
  rx: 2,
  fill: "white"
})));

const SvgDownloadIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 21 19",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download-icon.3aa7b6ab.svg";
export { ForwardRef as ReactComponent };